<template>
  <div class="rounded relative grid grid-cols-[auto_1fr] gap-x-4 gap-y-2">
    <Skeleton
      class="w-10 h-10 border border-neutral-300 dark:border-neutral-700 !rounded-full"
    />
    <div class="flex justify-between items-start min-w-0">
      <div class="space-y-1">
        <Skeleton class="h-5 w-32 mt-1" />
        <Skeleton class="h-3 w-[75%]" />
      </div>
      <NamiButton
        button-type="secondary"
        :icon="IconDots"
        small
        pill
        text
        disabled
      />
    </div>
    <div class="relative w-full col-start-2 space-y-2">
      <div
        class="opacity-70 cursor-text h-full"
        :style="{ minHeight: minTextboxHeight || '3rem' }"
      >
        {{ $t("components.feedCommentFormSkeletonLoader.placeholderText") }}
      </div>
    </div>
    <NamiDivider class="col-start-2 !my-0" />
    <div class="flex gap-2-mb-2 col-start-2">
      <NamiButton
        button-type="primary"
        :icon="IconPhotoPlus"
        small
        pill
        text
        disabled
      />
      <NamiButton class="ml-auto" button-type="primary" small pill disabled>
        <span class="px-1 flex items-center">
          <span class="mr-1">{{
            $t("components.feedCommentFormSkeletonLoader.buttonText")
          }}</span>
          <IconSend :size="18" />
        </span>
      </NamiButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconDots, IconPhotoPlus, IconSend } from "@tabler/icons-vue";

interface Props {
  minTextboxHeight?: string;
}

defineProps<Props>();
</script>

<style scoped lang="postcss"></style>
